<template>
  <router-view />
</template>

<style>
@import "@/assets/css/reset.css";
@import url("https://rsms.me/inter/inter.css");

html {
  font-family: "Inter", sans-serif;
  font-weight: 400;
}

@supports (font-variation-settings: normal) {
  html {
    font-family: "Inter var", sans-serif;
    font-weight: 400;
  }
}

body {
  font-family: "Inter";
  font-weight: 400;
}
</style>

<script>
export default {
  name: "App",
};
</script>
